import React from "react";
import { InputJson } from "nq-component";
import {
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import BaseFormPage from "../../../../../base/BaseFormPage";
import NavBar from "../../../../../components/navbar";
import WasteComponentFormPresenter from "./WasteComponentFormPresenter";

class WasteComponentFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false };
    this.presenter = new WasteComponentFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "waste_records";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add New " : "View ";
    return (
      <>
        <NavBar
          action={() => (
            <div className="dropdown dropstart d-inline-block">
              <i
                role="button"
                data-bs-toggle="dropdown"
                className="bi bi-three-dots-vertical"
              ></i>
              <div className="dropdown-menu fs-xs">
                <button
                  onClick={this.onClickAdvance.bind(this)}
                  className="dropdown-item py-3"
                >
                  <i className="bi bi-gear pe-2" />
                  Toggle Advance
                </button>
              </div>
            </div>
          )}
        />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                <i
                  onClick={() => this.navigateBack()}
                  className="bi bi-chevron-compact-left"
                  style={{ color: "black", cursor: "pointer" }}
                ></i>{" "}
                {label + "Waste Components"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <div
                  style={{
                    backgroundColor: "#f5f5f5",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "16px",
                    marginTop: "12px",
                  }}
                >
                  <h6
                    style={{
                      fontWeight: "600",
                      marginBottom: "8px",
                    }}
                  >
                    Details
                  </h6>
                  <hr style={{ marginTop: 0, marginBottom: "16px" }} />
                  <div style={{ lineHeight: "1.8", color: "#333" }}>
                    <div>
                      <strong>OR #:</strong> {object?.orNumber}
                    </div>
                    <div>
                      <strong>Product Name:</strong> {object?.name}
                    </div>
                    <div>
                      <strong>SKU:</strong> {object?.sku}
                    </div>
                    <div>
                      <strong>Amount:</strong> {object?.amount}
                    </div>
                    <div>
                      <strong>Void Date :</strong>{" "}
                      {object?.voidDate &&
                        new Date(object.voidDate).toLocaleString("en-PH", {
                          month: "long",
                          day: "numeric",
                          year: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                          timeZone: "Asia/Manila",
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(WasteComponentFormPage);
